import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, isInvalid, isSubmitting } from 'redux-form'
import { Card, Row, Container, Col } from 'react-bootstrap'
import * as actions from '../../../actions'
import PuestoCaladoPicker from '../../../../PuestoCaladoPicker/containers/PuestoCaladoPicker'
import PrinterPicker from '../../../../Printer/containers/PrinterPicker'
import CamposProcesoCalado0 from '../../../components/proceso/CamposProcesoCalado0'
import { FORM_PROCESO_CALADO } from '../../../../../config/forms'
import { CardActionArea, Button, IconButton } from '@material-ui/core'
import { confirmAlert } from 'react-confirm-alert'
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew'
import { cerealesColor } from '../../../../../config/cereales'

class ProcesoCalado0 extends Component {
  constructor (props) {
    super(props)
    this.selectPuestoCalado = this.selectPuestoCalado.bind(this)
    this.onPuestoCaladoChange = this.onPuestoCaladoChange.bind(this)
    this.selectPrinter = this.selectPrinter.bind(this)
    this.onPrinterChange = this.onPrinterChange.bind(this)
    this.openDialogPatente = this.openDialogPatente.bind(this)
    this.openDialogPdf = this.openDialogPdf.bind(this)
    this.handleClick = this.handleClick.bind(this)
    this.listarCamionesCalados = this.listarCamionesCalados.bind(this)
    this.state = { viewCamionesCalados: true }
  }

  selectPuestoCalado (puestoCalado, nombrePuestoCalado, calleA, calleB) {
    this.props.selectPuestoCalado(puestoCalado, nombrePuestoCalado, calleA, calleB)
  }

  selectPrinter (printer, printerName) {
    this.props.selectPrinter(printer, printerName)
  }

  onPuestoCaladoChange () {
    this.props.resetPuestoCalado()
  }

  onPrinterChange () {
    this.props.resetPrinter()
  }

  openDialogPatente (calle) {
    this.props.openDialogPatente(calle)
  }

  openDialogPdf (url) {
    this.props.openDialogPdf(url)
  }

  openDialogKeyboard () {
    this.props.openDialogKeyboard()
  }

  async listarCamionesCalados () {
    const esperoCamiones = await this.props.obtenerDatosCamionesCalados()
    console.log(esperoCamiones)
    this.props.openListadoCamionesCalados()
  }

  componentDidMount () {
    this.intervalEstadoCalle = setInterval(() => {
      const { nombrePuestoCalado } = this.props
      if (nombrePuestoCalado === 'Calle 1/2') {
        this.props.getEstadoCalle(1)
        this.props.getEstadoCalle(2)
      } else if (nombrePuestoCalado === 'Calle 3/4') {
        this.props.getEstadoCalle(3)
        this.props.getEstadoCalle(4)
      }
    }, 8000)
  }

  componentWillUnmount () {
    clearInterval(this.intervalEstadoCalle)
  }

  handleClick () {
    const {
      preingresoOn,
      nombrePuestoCalado
    } = this.props
    this.props.setPreingresoOn(!preingresoOn)

    if (!preingresoOn) {
      if (nombrePuestoCalado === 'Calle 1/2') {
        this.props.encender12()
        console.log('Se encendio puesto 1/2')
      } else if (nombrePuestoCalado === 'Calle 3/4') {
        this.props.encender34()
        console.log('Se encendio puesto 3/4')
      }
    } else {
      if (nombrePuestoCalado === 'Calle 1/2') {
        this.props.apagar12()
        console.log('Se apago puesto 1/2')
      } else if (nombrePuestoCalado === 'Calle 3/4') {
        this.props.apagar34()
        console.log('Se apago puesto 3/4')
      }
    }
  }

  renderCpeEnPreingreso (data) {
    if (data) {
      const cereal = data.cereal ? `${data.cereal.trim()}` : ''
      return (
        <>
          <h3 className='cpe-en-preingreso'>{data.numero}</h3>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            <div className='point-list' style={{ backgroundColor: cerealesColor[cereal] }} />
            <h4>{data.cereal}</h4>
          </div>
        </>
      )
    } else {
      return null
    }
  }

  render () {
    const {
      handleSubmit,
      nombrePuestoCalado,
      calleA,
      calleB,
      caladoImpresora,
      caladoImpresoraNombre,
      invalid,
      submitting,
      cpeEnPreingreso1,
      cpeEnPreingreso2,
      cpeEnPreingreso3,
      cpeEnPreingreso4,
      preingresoOn
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <div>
          <PuestoCaladoPicker
            onSubmit={this.selectPuestoCalado}
            show={nombrePuestoCalado == null} />
          <PrinterPicker
            onSubmit={this.selectPrinter}
            place='calado'
            name='printerCalado'
            show={caladoImpresora == null}
            titulo='Impresora para oblea de análisis' />
          <CamposProcesoCalado0
            onPuestoCaladoChange={this.onPuestoCaladoChange}
            nombrePuestoCalado={nombrePuestoCalado}
            onPrinterChange={this.onPrinterChange}
            printerName={caladoImpresoraNombre} />
          <br />
          <Container fluid className='align-items-center container-card-calado'>
            <Row className='justify-content-center row-card-calles-calado'>
              <Col md={6} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Card className='card-calle shadow bg-white rounded' disabled={invalid || submitting}>
                  <CardActionArea onClick={() => this.props.obtenerCPEcalle(calleB)} >
                    <Card.Header className='card-header-calado'>
                      <Card.Title style={{ textAlign: 'center', fontSize: '2rem', fontWeight: '300' }}>
                          Calle
                      </Card.Title>
                    </Card.Header>
                    <Card.Body className='card-body-calado'>
                      <Card.Title style={{ textAlign: 'center', fontSize: '4rem', fontWeight: '400' }}>
                        {calleB}
                      </Card.Title>
                    </Card.Body>
                  </CardActionArea>
                </Card>
                {(nombrePuestoCalado === 'Calle 1/2') && <> {this.renderCpeEnPreingreso(cpeEnPreingreso2)} </> }
                {(nombrePuestoCalado === 'Calle 3/4') && <> {this.renderCpeEnPreingreso(cpeEnPreingreso4)} </> }
              </Col>
              <Col md={6} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Card className='card-calle shadow bg-white rounded' disabled={invalid || submitting}>
                  <CardActionArea onClick={() => this.props.obtenerCPEcalle(calleA)} >
                    <Card.Header className='card-header-calado'>
                      <Card.Title style={{ textAlign: 'center', fontSize: '2rem', fontWeight: '300' }}>
                          Calle
                      </Card.Title>
                    </Card.Header>
                    <Card.Body className='card-body-calado'>
                      <Card.Title style={{ textAlign: 'center', fontSize: '4rem', fontWeight: '400' }}>
                        {calleA}
                      </Card.Title>
                    </Card.Body>
                  </CardActionArea>
                </Card>
                {(nombrePuestoCalado === 'Calle 1/2') && <> {this.renderCpeEnPreingreso(cpeEnPreingreso1)} </> }
                {(nombrePuestoCalado === 'Calle 3/4') && <> {this.renderCpeEnPreingreso(cpeEnPreingreso3)} </> }

              </Col>
            </Row>
          </Container>
        </div>
        <div className='container-vaciar-calle-calado'>
          <Button variant='contained' color='primary'
            onClick={() => {
              confirmAlert({
                title: 'Atención',
                message: '¿Esta seguro que desea vaciar la calle de calado?',
                buttons: [
                  {
                    label: 'Aceptar',
                    onClick: () => this.props.vaciarCalle(calleB)
                  },
                  {
                    label: 'Cancelar',
                    onClick: () => null
                  }
                ] })
            }
            } >
              Vaciar calle
          </Button>
          <Button variant='contained' color='primary'
            onClick={() => {
              confirmAlert({
                title: 'Atención',
                message: '¿Esta seguro que desea vaciar la calle de calado?',
                buttons: [
                  {
                    label: 'Aceptar',
                    onClick: () => this.props.vaciarCalle(calleA)
                  },
                  {
                    label: 'Cancelar',
                    onClick: () => null
                  }
                ] })
            }
            } >
              Vaciar calle
          </Button>
        </div>

        {/*  BOTONES ON/OFF PARA EQUIPOS DE PREINGRESO CALADO */}
        <IconButton onClick={() => {
          confirmAlert({
            title: 'Atención',
            message: 'Se encenderá el equipo de preingreso a calado. ¿Está de acuerdo?',
            buttons: [
              {
                label: 'Aceptar',
                onClick: () => this.handleClick()
              },
              {
                label: 'Cancelar',
                onClick: () => null
              }
            ] })
        }
        } className='button-power-calado'>
          { (!preingresoOn) && <PowerSettingsNewIcon style={{ fontSize: '3.2rem', padding: '10px', backgroundColor: '#f5263a', color: '#ffffff', borderRadius: '100px' }} /> }
        </IconButton>
        <IconButton onClick={() => {
          confirmAlert({
            title: 'Atención',
            message: '¿Esta seguro que desea apagar el equipo de preingreso a calado?',
            buttons: [
              {
                label: 'Aceptar',
                onClick: () => this.handleClick()
              },
              {
                label: 'Cancelar',
                onClick: () => null
              }
            ] })
        }
        } className='button-power-calado'>
          { (preingresoOn) && <PowerSettingsNewIcon style={{ fontSize: '3.2rem', padding: '10px', backgroundColor: '#3fb93f', color: '#ffffff', borderRadius: '100px' }} /> }
        </IconButton>
      </form>
    )
  }
}

const mapStateToProps = (state) => ({
  nombrePuestoCalado: state.calado.nombrePuestoCalado,
  show: state.calado.showCargaNoAdmitible,
  calleA: state.calado.calleA,
  calleB: state.calado.calleB,
  caladoImpresora: state.calado.caladoImpresora,
  caladoImpresoraNombre: state.calado.caladoImpresoraNombre,
  invalid: isInvalid(FORM_PROCESO_CALADO)(state),
  submitting: isSubmitting(FORM_PROCESO_CALADO)(state),
  preingresoOn: state.calado.preingresoOn,
  cpeEnPreingreso1: state.calado.cpeEnPreingreso1,
  cpeEnPreingreso2: state.calado.cpeEnPreingreso2,
  cpeEnPreingreso3: state.calado.cpeEnPreingreso3,
  cpeEnPreingreso4: state.calado.cpeEnPreingreso4
})

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_PROCESO_CALADO,
  destroyOnUnmount: false,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true
})

export default withRedux(withReduxForm(ProcesoCalado0))
